import React from 'react';
import styles from './GlobalMapSearch.module.css';

/**
 * Persistent hint surfacing the `/` and `//` prefix affordances.
 * Rendered at the bottom of the recents dropdown and the no-results
 * state — not alongside live result rows. Two prefixes, two flows:
 *   - `/`  for scoped slash commands (search, calls, parcels, etc.)
 *   - `//` for action commands (e.g. `// add` external GIS layers)
 */
export const CommandHintFooter: React.FC = () => (
  <div className={styles.dropdownFooter}>
    <span className={styles.dropdownFooterTips}>
      Tip: type <span className={styles.dropdownFooterKey}>/</span> for commands
      or <span className={styles.dropdownFooterKey}>//</span> for actions
    </span>
    <span className={styles.dropdownFooterAction}>
      <span className={styles.dropdownFooterKey}>Enter</span> to search
    </span>
  </div>
);

export default CommandHintFooter;
